import { Component, OnInit } from '@angular/core';

import { PortfolioManagement } from '../../../shared/models/portfolioManagement.model';
import { PortfolioState } from '../../../shared/models/portfolioState.model';
import { CollectionManagementResult } from '../../../shared/models/collectionManagementResult.model';
import { DocumentSource } from '../../../shared/models/documentSource.model';

import { PortfolioService } from '../../../shared/_services/portfolio.service';

import { ActivatedRoute } from '@angular/router';
import { DebtorManagement } from '../../../shared/models/debtorManagement.model';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-detail-portfolio',
  templateUrl: './detail-portfolio.component.html',
  styleUrls: ['./detail-portfolio.component.css']
})
export class DetailPortfolioComponent implements OnInit {

  fieldArray: any[] = [];
  PortfolioList: PortfolioManagement[];
  collectionManagementResultList: CollectionManagementResult[] = [];
  collectionManagementResultsActiveList: CollectionManagementResult[] = [];
  portfolioStateList: PortfolioState[] = [];
  documentSourceList: DocumentSource[] = [];
  debtorData: DebtorManagement;
  idDebtor: number;
  idPolicy: number;
  error: string;

  p: number = 1;

  constructor(private portfolioService: PortfolioService, private route: ActivatedRoute) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.idDebtor = params.id;
      this.idPolicy = params.idPolicy;
    });

    // petición de estados de póliza
    this.portfolioService.getPortfolioState()
      .subscribe(portfolioState => this.portfolioStateList = portfolioState);

    // petición de estados y resultados de gestiones
    this.portfolioService.getCollectionResult()
      .subscribe(collectionResult => {
        this.collectionManagementResultList = collectionResult;
        this.collectionManagementResultsActiveList = collectionResult.filter(x => x.isActive == true);
      });

    // petición de tipos de documento 
    this.portfolioService.getDocumentSource()
      .subscribe(documentSource => this.documentSourceList = documentSource);

    if (typeof this.idPolicy === 'undefined') {

      this.portfolioService.getActiveByTercero(this.idDebtor)
        .subscribe(portfolioList => {
          this.PortfolioList = portfolioList;
        },
          error => {
            this.PortfolioList = undefined;
            this.error = error;
          }
        );
    } else {
      this.portfolioService.getAllByTercero(this.idDebtor)
      .subscribe(portfolioList => {
        this.PortfolioList = portfolioList;
      },
      error => {
        this.PortfolioList = undefined;
        this.error = error;
      }
      );
    }


    this.portfolioService.getDebtorById(this.idDebtor)
      .subscribe(debtor => {
        this.debtorData = debtor;
      });
  }

  //updateManagement(generalManagement: CollectionManagement) {
  //  this.PortfolioList.forEach(element => {
  //    element.managementList.push(generalManagement);
  //    if (generalManagement.lock)
  //      element.lock = true
  //    });    
  //}

  refreshPortfolio(idPortfolio: any) {
    this.portfolioService.getActiveByTercero(this.idDebtor)
      .subscribe(portfolioList => {
        this.PortfolioList = portfolioList;

        let saveIdPortfolio = this.PortfolioList.find(p => p.idPortfolio == idPortfolio);
        if (typeof saveIdPortfolio !== 'undefined') {
          this.idPolicy = idPortfolio;
        } else {
          this.idPolicy = undefined;
        }
      },
      error => {
        this.PortfolioList = undefined;
          this.error = error;
        }
    );

    this.portfolioService.getDebtorById(this.idDebtor)
      .subscribe(debtor => {
        this.debtorData = debtor;
      });
  }
}
